import { useEffect, useState } from "react";
import Header from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { fetchPaymentHistory } from "../redux/paymentSlice";

function History() {
  const dispatch = useDispatch();
  const { history, loading, error } = useSelector((state) => state.payment);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [markFilter, setMarkFilter] = useState("All");
  const profilesPerPage = 10;
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = () => {
    setSearchQuery(searchTerm);
  };

  useEffect(() => {
    dispatch(fetchPaymentHistory());
  }, [dispatch]);

  const filteredProfiles = history.filter((profile) => {
    const matchesGender =
      markFilter === "All" ||
      profile.gender?.toLowerCase() === markFilter.toLowerCase();

    const matchesSearch =
      searchQuery.trim() === "" ||
      Object.values(profile)
        .concat(
          Object.values(profile.userDetails || {}),
          Object.values(profile.userDetails?.profile || {})
        )
        .some((val) =>
          val?.toString().toLowerCase().includes(searchQuery.toLowerCase())
        );

    return matchesGender && matchesSearch;
  });

  const totalPages = Math.ceil(filteredProfiles.length / profilesPerPage);
  const startIndex = (currentPage - 1) * profilesPerPage;
  const currentProfiles = filteredProfiles.slice(
    startIndex,
    startIndex + profilesPerPage
  );

  const handlePrevious = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  useEffect(() => {
    setCurrentPage(1);
  }, [markFilter]);

  return (
    <>
      <Header />
      <div className="container py-3">
        <div className="row g-2">
          <div className="col-8">
            <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
              <table class="table mb-0 text-nowrap table-centered">
                <thead class="bg-dark">
                  <tr>
                    <th className="w-10 text-white">No.</th>
                    <th className="lh-1 w-60 text-white">
                      Details
                      <i className="bi bi-info-circle ms-2 text-white"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentProfiles.map((profile, index) => (
                    <tr key={startIndex + index} className="bg-white-light">
                      <td>{startIndex + index + 1}.</td>
                      <td className="lh-sm py-4">
                        <span class="text-dark">User ID</span> &mdash;{" "}
                        {profile.userId}
                        <br />
                        <span class="text-dark">Name</span> &mdash;{" "}
                        {profile.userDetails.name}
                        <br />
                        <span class="text-dark">Mobile No.</span> &mdash;{" "}
                        {profile.userDetails.mobile}
                        <br />
                        <span class="text-dark">
                          Email Address
                        </span> &mdash; {profile.userDetails.email}
                        <hr className="w-25" />
                        <span class="text-dark">
                          Membership ID
                        </span> &mdash; {profile.membershipId}
                        <br />
                        <span class="text-dark">Amount</span> &mdash;{" "}
                        {profile.amount}
                        <br />
                        <span class="text-dark">Status</span> &mdash;{" "}
                        {profile.status}
                        <br />
                        <span class="text-dark">Order ID</span> &mdash;{" "}
                        {profile.razorpay_order_id} <br />
                        <span class="text-dark">Payment ID</span> &mdash;{" "}
                        {profile.razorpay_payment_id}
                        <br />
                        <span class="text-dark">Date</span> &mdash;{" "}
                        {new Date(profile.paidAt).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-4">
            <div className="bg-danger-soft rounded-4 p-5">
              <div className="d-flex bg-white justify-content-between rounded-pill mb-3">
                <form
                  className="d-flex align-items-center"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSearch();
                  }}
                >
                  <span className="position-absolute ps-3 search-icon">
                    <i className="bi bi-filter-circle-fill ms-1" />
                  </span>
                  <input
                    type="search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="form-control ps-7 rounded-3 border-0 rounded-pill"
                    placeholder="Filter Data"
                  />
                </form>
                <span
                  onClick={handleSearch}
                  class="btn btn-warning px-5 fs-6 fw-semibold rounded-pill fit-content"
                >
                  Search
                </span>
              </div>

              <h3 className="m-0 lh-sm">All Transactions</h3>
              <p>Users Who’ve Purchased Membership so far</p>
              <p className="fw-medium text-dark mb-2">
                {filteredProfiles.length} Transaction
                {filteredProfiles.length !== 1 ? "s" : ""}
              </p>

              {loading && (
                <div className="mt-2">
                  <div
                    class="spinner-border mt-2 text-dark"
                    role="status"
                  ></div>
                </div>
              )}
              {error && <div className="text-danger">{error}</div>}

              <hr className="border-light" />

              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-outline-dark rounded-4"
                  disabled={currentPage === 1}
                  onClick={handlePrevious}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                <span className="text-dark">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-outline-dark rounded-4"
                  disabled={currentPage === totalPages}
                  onClick={handleNext}
                >
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default History;
